import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (amount, currency = 'MYR') => {
  return new Intl.NumberFormat('en-MY', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-MY', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-MY', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getRankLabel = (rank) => {
  const labels = {
    agent: 'Agent',
    rm: 'Relationship Manager',
    avp: 'Assistant Vice President',
    svp: 'Senior Vice President',
    evp: 'Executive Vice President',
  };
  return labels[rank] || rank;
};

export const getStatusColor = (status) => {
  const colors = {
    available: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    reserved: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    booked: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    sold: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
    pending: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    approved: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    rejected: 'bg-red-500/20 text-red-400 border-red-500/30',
    escalated: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    completed: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    cancelled: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
    deposit_paid: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    spa_signed: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
    paid: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  };
  return colors[status] || 'bg-slate-500/20 text-slate-400 border-slate-500/30';
};

export const getRankColor = (rank) => {
  const colors = {
    agent: 'bg-slate-500/20 text-slate-300',
    rm: 'bg-blue-500/20 text-blue-400',
    avp: 'bg-purple-500/20 text-purple-400',
    svp: 'bg-amber-500/20 text-amber-400',
    evp: 'bg-gradient-to-r from-amber-400 to-yellow-300 text-black',
  };
  return colors[rank] || 'bg-slate-500/20 text-slate-300';
};

export const generateReferralLink = (code) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/ref/${code}`;
};
